import { render } from "./KeywordView.vue?vue&type=template&id=04423902&scoped=true"
import script from "./_KeywordView.js?vue&type=script&lang=js&external"
export * from "./_KeywordView.js?vue&type=script&lang=js&external"

import "./_KeywordView.less?vue&type=style&index=0&id=04423902&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04423902"]])

export default __exports__